import styled, { css } from 'styled-components';

type ButtonAttributes = {
  disabled?: boolean;
  width?: string;
};

export default styled.button<ButtonAttributes>(
  ({ disabled, width }) => css`
    transition:
      color 0.3s,
      opacity 0.5s,
      border-color 0.3s,
      background-color 0.3s;

    background-color: rgb(187 187 187);
    border: 1px solid rgb(34 34 34);

    backface-visibility: hidden;
    letter-spacing: normal;

    color: rgb(34 34 34);
    border-radius: 25px;

    text-align: center;
    position: relative;
    padding: 15px 20px;

    min-width: 200px;
    max-width: 300px;

    margin: 0px auto;
    font-size: 1rem;

    cursor: pointer;
    line-height: 1;
    display: block;

    height: 50px;
    width: auto;

    &:active {
      background-color: rgb(255 255 255);
      border-color: rgb(0 0 0);
      color: rgb(0 0 0);
    }

    ${disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}

    ${width &&
    css`
      width: ${width};
    `}
  `
);
